<template>
  <jw-modal :visible="data.priceVisible" @cancel="priceCancel" class="price-modal" :mask-closable="false" title-align="start" width="750px" :body-style="{ height: data.priceList?.length >= 10 ? '300px' : '200px', padding: '0px 20px' }">
    <template #title>{{ $t('选择价格') }}</template>
    <jw-table :data="data.priceList" :pagination="false" :loading="loading" :columns="priceCloumns" row-key="id" :rowSelection="{ selectedRowKeys: data.selectedRowKeys, type: 'radio' }" ref="xlPriceTable" @select="priceSelect" :size="large" :bordered="{ wrapper: false, headerCell: true }">
      <template #tr="{ record }">
        <tr :class="[record.isOutTime ? 'my-tr' : '']" />
      </template>
      <!--标准价格 -->
      <template #price="{ record }">
        <jw-tooltip :content="$t('tips.contractPrice')" position="rt" mini v-if="record.isOutTime">
          <span style="cursor: pointer">{{ record.price }}</span></jw-tooltip
        >
        <template v-else>{{ record.price }}</template>
      </template>
      <!-- 币种 -->
      <template #currencyValue="{ record }">
        {{ record.currencyValue || '-' }}
      </template>
      <!-- 时长单位 -->
      <template #timeTypeValue="{ record }">
        {{ record.timeTypeValue || '-' }}
      </template>
      <!-- 规格单位 -->
      <template #unitValue="{ record }">
        {{ record.unitValue || '-' }}
      </template>
      <!-- 操作插槽 -->
      <template #startTime="{ record }">
        <p>{{ record.startTime }}{{ $t('至') }}{{ record.endTime }}</p>
      </template>
    </jw-table>
    <template #footer>
      <jw-button @click="priceOk" type="primary">{{ $t('确定') }}</jw-button>
    </template>
  </jw-modal>
</template>
<script setup>
import { reactive, inject } from 'vue';
import { productService } from '@/api/';
import useLoading from '@/hooks/loading';
import { tools } from '@/utils/tools.js';
const { loading, setLoading } = useLoading(false);
const { updateCustomForm } = inject('methods'); //父组件方法
const data = reactive({
  priceVisible: false,
  priceList: [],
  selectedRowKeys: [],
  record: []
});

//价格表头
const priceCloumns = [
  {
    title: '标准价格',
    dataIndex: 'price',
    width: 150,
    slotName: 'price',
    ellipsis: true,
    tooltip: true
  },
  {
    title: '币种',
    dataIndex: 'currencyValue',
    slotName: 'currencyValue',
    width: 80
  },
  {
    title: '时长单位',
    dataIndex: 'timeTypeValue',
    slotName: 'timeTypeValue',
    width: 100
  },
  {
    title: '规格单位',
    dataIndex: 'unitValue',
    slotName: 'unitValue',
    width: 100
  },
  {
    title: '有效期',
    dataIndex: 'startTime',
    slotName: 'startTime',
    width: 210,
    fixed: 'right'
  }
];
//关闭选择价格弹窗
const priceCancel = () => {
  data.priceVisible = false;
};
// 显示
const priceShow = (id) => {
  getProductPrice(id);
  data.priceVisible = true;
};
// 确定
const priceOk = () => {
  updateCustomForm(data.record);
  data.priceVisible = false;
};
// 清空选中
const clearChecked = () => {
  data.selectedRowKeys = [];
  data.record = {};
};
//选中价格
const priceSelect = (rowKeys, rowKey, record) => {
  console.log('rowKeys', rowKeys, rowKey, record);
  data.selectedRowKeys = rowKeys;
  data.record = record;
};
//获取产品价格列表
const getProductPrice = async (id) => {
  data.priceList = [];
  setLoading(true);
  try {
    const res = await productService.getProductPrice({ productId: id });
    data.priceList = res.result?.records;
    setLoading(false);
    data.priceList?.map((item) => {
      item.disabled = item.isOutTime;
      item.price = tools.getPrice(item.price);
    });
    const count = data.priceList?.filter((item) => !item.isOutTime);
    if (count?.length == 1) {
      priceSelect([count[0]?.id], count[0].id, count[0]);
      updateCustomForm(count[0]);
    }
  } catch (e) {
    setLoading(false);
    console.log(e);
  }
};
defineExpose({ priceShow, clearChecked, getProductPrice });
</script>
